<template>
  <div class="site-topbar">
    <div class="container">
      <div class="topbar-nav"></div>
      <div class="topbar-cart" v-show="is_login">
        <a rel="nofollow" href="/quick" class="cart-mini">
          <em class="iconfont-cart"></em>
          <em class="iconfont-cart-full hide"></em>快速下单
        </a>
      </div>
      <div class="topbar-cart" v-show="is_login">
        <a rel="nofollow" href="/inquiry" class="cart-mini">
          <em class="iconfont-cart"></em>
          <em class="iconfont-cart-full hide"></em>报价篮
          <span class="cart-mini-num J_cartNum" v-show="global.inquiry_count">({{ global.inquiry_count }})</span>
        </a>
      </div>
      <div class="topbar-cart" v-show="is_login">
        <a rel="nofollow" href="/cart" class="cart-mini">
          <em class="iconfont-cart"></em>
          <em class="iconfont-cart-full hide"></em>购物车
          <span class="cart-mini-num J_cartNum" v-show="global.cart_count">({{ global.cart_count }})</span>
        </a>
      </div>
      <div class="topbar-info">
        <div v-show="!is_login">
          <a rel="nofollow" href="/login" class="link">登录</a>
          <span class="sep">|</span>
          <a href="/register" class="link">注册</a>
          <span class="sep">|</span>
        </div>
        <div v-show="is_login">
          <el-dropdown class="link" style="height: 40px; line-height: 40px" @command="onCommand">
            <span class="el-dropdown-link">
              {{ nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  个人中心
                </el-dropdown-item>
                <el-dropdown-item command="order">我的订单</el-dropdown-item>
                <el-dropdown-item command="inquiry">报价篮</el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <span v-show="is_login" class="sep">|</span>
          <router-link to="/order">我的订单</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { session, api, config } from "@/assets/js/util.js";
export default {
  name: "SiteToper",
  inject: ["global"],
  data() {
    return {
      is_login: false,
      nickname: "",
    };
  },
  mounted() {
    this.is_login = config.get("is_login");
    this.nickname = config.get("nickname");
    this.getCartCount();
    this.getInquiryCount();
  },
  methods: {
    onCommand(command) {
      this.$router.push("/" + command);
    },
    getCartCount() {
      let that = this;
      api.get("cart/count").then(function (res) {
        if (res.code) {
          that.global.cart_count = res.data;
        } else {
          config.set('is_login', false);
          config.set('nickname', '');
          config.set('token', '');
          that.is_login = false;
        }
      });
    },
    getInquiryCount() {
      let that = this;
      api.get("inquiry/count").then(function (res) {
        if (res.code) {
          that.global.inquiry_count = res.data;
        }
      });
    },
  },
};
</script>
<style scoped></style>
